import { format } from 'date-fns';

import { type AssetCustomFieldValue, CustomFieldTypeName } from '@air/api/types';
import { parseAirDateToISO } from '@air/utilities';

import {
  getCustomFieldDateValues,
  getCustomFieldPlainTextValues,
  getCustomFieldSingleAndMultiSelectValues,
} from '~/utils/CustomFields';

export const formatCustomFieldValueAsString = (field: AssetCustomFieldValue): string => {
  switch (field.type.title) {
    case CustomFieldTypeName.singleSelect:
    case CustomFieldTypeName.multiSelect: {
      const selectValues = getCustomFieldSingleAndMultiSelectValues(field);
      if (!selectValues) return '';
      const values = Array.isArray(selectValues) ? selectValues : [selectValues];
      return values.map((v) => v.value).join(', ');
    }
    case CustomFieldTypeName.plainText: {
      return getCustomFieldPlainTextValues(field) || '';
    }
    case CustomFieldTypeName.date: {
      const dateValue = getCustomFieldDateValues(field);
      if (!dateValue) return '';
      // Product decision: avoid comma in date string (e.g. "Feb 23, 2026") which triggers
      // RFC 4180 quoting in CSV output. "MMMM d yyyy" formats without commas for cleaner spreadsheet display.
      return format(parseAirDateToISO(dateValue), 'MMMM d yyyy');
    }
    default:
      return '';
  }
};
